module.exports = __webpack_public_path__ + "img/fast-delivery.5be09a6c.png";